import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'
import { useGroupedHover } from '@aytm/app/insights/dashboard/components/hooks'

import usePool from '@duckness/use-pool'
import InsightsDashboardPool from '@aytm/app/insights/dashboard/duckness/InsightsDashboardPool'

import { isRowAveragesUid } from '@aytm/app/insights/dashboard/lib/config'

import SubjectText from '../SubjectText'

import Popup from './Popup'

import './Subject.scss'
import { getCurrentBlock } from '../../../helpers/requests'

const CLASS = 'insights-portal-subject'

const Subject = props => {
  const className = props.className || CLASS

  const { isSharedView } = staticStore

  const { editor, trackTarget } = usePool(InsightsDashboardPool, state => {
    const block = getCurrentBlock(state)
    return { editor: state.editor || null, trackTarget: block?.getObject('trackTarget') || 'entity' }
  })

  const index = props.index ?? -1
  const getColumnData = props.onGetColumnData || null
  const renderDateRange = props.onRenderDateRange || null

  const subject = useMemo(() => props.subject || {}, [props.subject])
  const showControl = useMemo(
    () => !isRowAveragesUid(subject.uid) && 'entity' === trackTarget,
    [subject.uid, trackTarget]
  )

  const { text } = useMemo(() => getColumnData?.(props.item), [getColumnData, props.item])
  const range = useMemo(() => renderDateRange?.(subject.from, subject.to), [renderDateRange, subject])

  const [ref] = useGroupedHover(props.index, 'subject')

  return (
    <div className={className} disabled={isSharedView} ref={ref} data-uid={subject.uid}>
      <Popup
        index={props.index}
        item={props.item}
        subject={subject}
        subjects={props.subjects}
        showImage={props.showImage}
        editor={editor}
        onEditorChange={props.onEditorChange}
      />
      <SubjectText
        className={`${className}-text`}
        blink={props.blink}
        text={text}
        range={range}
        index={index}
        item={props.item}
        wait={props.wait}
        swap={props.swap}
        edit={editor?.type}
        showControl={showControl}
        onSwapChange={props.onSwapChange}
        onEditorChange={props.onEditorChange}
      />
      {props.children}
    </div>
  )
}

const Empty = ({ children }) => <div className={`${CLASS} ${CLASS}-empty`}>{children}</div>

Empty.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
}

Subject.Empty = Empty

Subject.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  item: PropTypes.object,
  subject: PropTypes.object,
  subjects: PropTypes.object,
  editor: PropTypes.any,
  showImage: PropTypes.any,
  children: PropTypes.any,
  blink: PropTypes.any,
  swap: PropTypes.any,
  wait: PropTypes.any,
  onGetColumnData: PropTypes.func,
  onRenderDateRange: PropTypes.func,
  onSwapChange: PropTypes.func,
  onEditorChange: PropTypes.func
}

Subject.defaultProps = {
  index: -1,
  subject: {},
  subjects: {},
  blink: true
}

export default Subject
